import { useCallback, useEffect, useState } from "react";

import {
  ENV_CONFIG,
  type Environment,
  getEnvironment,
  setEnvironment,
  subscribeToEnvironment,
} from "../api/client";

const ENV_ORDER: Environment[] = ["dev", "prod", "test"];

export function EnvironmentSwitcher() {
  const [env, setEnv] = useState<Environment>(getEnvironment);

  // Stay in sync if another part of the app calls setEnvironment() directly.
  useEffect(() => {
    return subscribeToEnvironment(() => {
      setEnv(getEnvironment());
    });
  }, []);

  const handleChange = useCallback((e: React.ChangeEvent<HTMLSelectElement>) => {
    const newEnv = e.target.value as Environment;
    if (ENV_CONFIG[newEnv].disabled) return;
    setEnvironment(newEnv);
    setEnv(newEnv);
  }, []);

  const config = ENV_CONFIG[env];

  return (
    <div className="flex flex-col gap-0.5">
      <label className="flex items-center gap-2 text-sm">
        <span className="text-slate-500 text-xs font-medium uppercase tracking-wide">Env</span>
        <select
          value={env}
          onChange={handleChange}
          data-testid="env-switcher"
          className="px-2 py-1 border border-slate-300 rounded text-sm bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        >
          {ENV_ORDER.map((e) => {
            const cfg = ENV_CONFIG[e];
            return (
              <option key={e} value={e} disabled={cfg.disabled}>
                {cfg.label}
                {cfg.disabled ? " (not configured)" : ""}
              </option>
            );
          })}
        </select>
      </label>
      <span className="text-xs text-slate-400 pl-8">
        DB:{" "}
        <code className="font-mono text-slate-600">{config.dbLabel}</code>
      </span>
    </div>
  );
}
